function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { RadioUncheck } from '../../common/icons';
export function TimelineItem(props) {
  var title = props.title,
      time = props.time,
      description = props.description,
      _props$position = props.position,
      position = _props$position === void 0 ? 'right' : _props$position,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? '#D0D0D0' : _props$color,
      icon = props.icon,
      extra = _objectWithoutProperties(props, ["title", "time", "description", "position", "className", "color", "icon"]);

  var cls = classnames(usePrefixCls('timeline-item'), position === 'right' ? '' : 'revert-item', className);
  var timeCls = classnames('timeline-time', description ? '' : 'block-line');
  var defaultIconStyles = {
    color: color
  };
  var titleDom = [React.createElement("span", {
    key: 0,
    className: "timeline-title"
  }, title), React.createElement("span", {
    key: 1,
    className: timeCls
  }, time)];
  return React.createElement("div", Object.assign({
    className: cls
  }, extra), React.createElement("div", {
    className: "timeline-line"
  }, icon ? typeof icon === 'function' ? icon({
    style: defaultIconStyles
  }) : icon : React.createElement(RadioUncheck, {
    style: defaultIconStyles
  })), React.createElement("div", {
    className: "timeline-content"
  }, position === 'left' && description ? titleDom.reverse() : titleDom, description ? React.createElement("div", {
    className: "timeline-descript"
  }, description) : null));
}